import axios from '@/axios.js';
import auth from '@/services/authService';

let accessToken = localStorage.accessToken;
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

const updateStates= (commit, response) => {
  let result = response.data;

  if (!result.data.token) {
    reject('Server error: cannot get access token');
  }

  localStorage['accessToken'] = result.data.token;
  auth.setAccessTokenInCookie(result.data.token);
  commit('UPDATE_USER_INFO', result.data.user, {root: true})
  commit('user/UPDATE_USER_INFO', result.data.user, {root: true})

  commit('SET_BEARER', result.data.token);
  commit('UPDATE_JWT_INFO', result.data.token);
}


export default {
  namespaced: true,

  actions: {
    login ({ commit, dispatch }, payload ) {
      return new Promise( (resolve, reject) => {
        axios.post('/auth/login', {
          email: payload.email,
          password: payload.password
        }).then( response => {
          updateStates(commit, response);
          resolve(response);
        }).catch( error => {
          if (!error.data || !error.data.errors) {
            reject({ message: error.statusText });
          } else {
            reject({ message: error.data.errors })
          }
        }); 
      })
    },

    signup ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('auth/signup', payload).then( response => {
          updateStates(commit, response);
          resolve(response);
        }).catch( error => {
          //console.log(error);
          if (!error.data || !error.data.errors) {
            reject({ message: error.statusText });
          } else {
            reject({ message: error.data.errors })
          }
        });
      });
    },

    verify ({ commit, dispatch }, code) {
      return new Promise((resolve, reject) => {
        axios.get('auth/verify/' + code).then( response => {
          commit('user/UPDATE_USER_INFO', response.data.data.user, {root: true})
          resolve(response);
        }).catch( error => {
          reject(error);
        });
      });
    },

    reloadLogin ({ commit, dispatch }, code) {
      let iat = auth.getStoredAccessToken();
      axios.defaults.headers.common['Authorization'] = `Bearer ${iat}`
      return new Promise((resolve, reject) => {
        axios.post('/auth/refresh-token').then((result) => {
          commit('organization/SET_CURRENT_ORGANIZATION', result.data.data.user.organizations, { root: true });
          updateStates(commit, result);
          resolve(result);
        }).catch(error => {
          reject(error);
        });
      })
    },

    async switchOrganization( {commit}, param) {
      if (isNaN(param.organization_id)) {
        throw "Invalid organization_id";
      }

      try {
        let res = await axios.patch('/auth/organization', {
          user_id: param.user_id,
          organization_id: param.organization_id
        });
        // changing role
        let role_name = res.data.data.role_name;
        if (['owner', 'admin', 'sales', 'agent'].indexOf(role_name) > -1) {
          param.acl.change(role_name);
        }
        commit('user/UPDATE_SELECTED_ORGANIZATION', res.data.data, { root: true });
      } catch(e) {
        throw e;
      }
    }
  },

  getters: {},

  mutations: {
    SET_BEARER (state, accessToken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
    },

    UPDATE_JWT_INFO (state, token) {
      let parsedJwt = {}

      localStorage['accessToken'] = token;

      parsedJwt = JSON.parse(atob(token.split('.')[1]));
      state.token = token;
      state.tokenExpiry= new Date(parsedJwt.exp * 1000);
    },
  },

  state: {
    isUserLoggedIn: () => {
      return auth.getLoginStatus() == 2 && auth.getOnboardStep >=3;
    }
  },
}
